module.exports = __webpack_public_path__ + "images/assets/09f3647673920009fe752881b9e15b13.svg";